import { render, staticRenderFns } from "./html_step.vue?vue&type=template&id=2b6973f3&scoped=true"
import script from "./html_step.vue?vue&type=script&lang=js"
export * from "./html_step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6973f3",
  null
  
)

export default component.exports